export default __webpack_public_path__ + "static/media/pyramid.540fd96b.png";